import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <section className="bg-white" data-testid="page-not-found">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-32 text-center">
        <div className="overline rule-teal mx-auto inline-block">404</div>
        <h1 className="font-display text-5xl sm:text-6xl mt-6 text-[#0B2E5C] leading-tight">
          This page is off the balance sheet.
        </h1>
        <p className="mt-6 text-[#475569] font-light text-lg">
          The page you're looking for doesn't exist — or has moved.
        </p>
        <Link to="/" data-testid="not-found-home-link" className="inline-block mt-10">
          <Button className="rounded-sm bg-[#0B2E5C] hover:bg-[#082142] text-white h-12 px-7">
            Back to home
          </Button>
        </Link>
      </div>
    </section>
  );
}
